import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import attendancesReport from "./attendanceReportService";

const useAttendanceReport = () => {
  const { id: trainingId } = useParams();
  const navigate = useNavigate();

  const { data, isFetching } = useQuery(["attendancesTrainingReport", trainingId], () => attendancesReport.getAttendancesReportByTraining(trainingId), {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  const navigateToAttendancesReport = () => navigate(`/validateAttendanceManager/${trainingId}`);

  return { data: data?.data, isFetching, navigateToAttendancesReport };

};

export default useAttendanceReport;